import BuildAndCarIcon from './BuildAndCarIcon';

export default BuildAndCarIcon;
